import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import { ErrorMessage } from "@/shared/components";
import { useQueuesList } from "../model";
import { QueueCard } from "./QueueCard";
import { QueuesFilter } from "./QueuesFilter";

/**
 * Реестр очередей Bull: карточка на очередь со счётчиками задач по статусам.
 * Счётчик — ссылка на список задач очереди в этом статусе.
 */
export function Queues() {
  const { nodes, loading, error, filter, setFilter, sort, setSort } =
    useQueuesList();

  if (error) return <ErrorMessage error={error} />;

  return (
    <Box sx={{ p: 1 }}>
      <Stack spacing={1}>
        <QueuesFilter
          filter={filter}
          setFilter={setFilter}
          sort={sort}
          setSort={setSort}
        />

        {loading && nodes.length === 0 && <LinearProgress />}

        {nodes.map((queue) => (
          <QueueCard queue={queue} key={queue.id} />
        ))}
      </Stack>
    </Box>
  );
}
